import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 12h-15","key":"svg-0"}],["path",{"d":"M6 9l-3 3l3 3","key":"svg-1"}],["path",{"d":"M21 9l-3 3l3 3","key":"svg-2"}]]

/**
 * IconArrowLeftTail
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbGVmdC10YWlsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xOCAxMmgtMTUiIC8+CiAgPHBhdGggZD0iTTYgOWwtMyAzbDMgMyIgLz4KICA8cGF0aCBkPSJNMjEgOWwtMyAzbDMgMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-left-tail
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowLeftTail = createReactComponent('outline', 'arrow-left-tail', 'ArrowLeftTail', __iconNode);

export default IconArrowLeftTail;